<template>
  <div class="screen border">
    <div class="cover">
      <img v-if="imageUrl" :src="imageUrl" :alt="title || ''" class="cover-image" />
      <img
        v-else
        :src="'/static/icons/article-preview-default.svg'"
        class="cover-default"
        alt=""
      />
    </div>
    <div class="detail">
      <div class="type">Voucher</div>
      <div class="title">
        {{ title || "หัวข้อ" }}
      </div>
      <div class="date">
        {{ previewDate | moment-full }}
      </div>
      <hr />
      <div v-safe-html="contentHtml" class="contents"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    imageUrl: {
      type: String,
      default: null,
    },
    contentHtml: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      previewDate: new Date(),
    };
  }
};
</script>

<style lang="scss" scoped>
.cover {
  background-color: #8c8786;
  margin: 0 auto;
  overflow: hidden;
  border-bottom: 1px solid #eee;

  &-default {
    position: relative;
    width: 70px;
    margin: 35px;
    top: calc(50% - 35px);
  }
  &-image {
    position: relative;
    width: 100%;
    height: 160px;
    object-fit: fill;
  }
}
.detail {
  padding: 10px;
}
.type {
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  text-align: left;
  color: #ef7e18;
}
.title {
  font-size: 24px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: -0.1px;
  text-align: left;
  color: #000000;
  overflow-wrap: break-word;
}
.date {
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: -0.1px;
  text-align: left;
  color: #616161;
}
hr {
  width: 40%;
}
.contents {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}
p {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}
a {
  color: #ff0000;
}
</style>
